import React, { useState } from "react";
import CustomButton from "../CustomButton";
import ModalLayout from "../layouts/ModalLayout";
import CustomInput from "../CustomInput";

interface Props {
  onClose?: () => void;
  onSuccess?: (date: string) => void;
}


export default function StaffAttendanceReportDateWise({ onClose, onSuccess }: Props) {
  const [date, setDate] = useState(
    new Date().toISOString().split("T")[0],
  );

  const handleView = (e: React.FormEvent) => {
    e.preventDefault();

    if (!date) return;

    onSuccess?.(date);
    onClose?.();
  };

  return (
    <ModalLayout onClose={onClose}>
      <form className="flex flex-col gap-8 max-w-xl" onSubmit={handleView}>
        <h3 className="text-xl font-semibold text-neutral-400">
          Attendance Report - Date Wise
        </h3>

        <CustomInput
          name="date"
          label="Date"
          value={date}
          type="date"
          onChange={(e) => setDate(e.target.value)}
        />

        <div className="flex justify-end gap-5">
          <CustomButton
            color="bg-neutral-200"
            text="Cancel"
            onClick={onClose}
          />

          <CustomButton
            color="bg-primary-500"
            text="View"
            type="submit"
          />
        </div>
      </form>
    </ModalLayout>
  );
}
